<div class="appointment-card" [style.border-color]="color">
    <div class="head" [style.background-color]="color">
      <div>
        <div class="day">{{day}}</div>
        <div class="time">{{time}}</div>
      </div>
    </div>
    <div class="body">
      <div>
        <div class="title" [style.color]="color">{{title}} 
          <div [pTooltip]="tooltip" style="height: 14px;">
            <svg  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <g clip-path="url(#clip0_1441_26168)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9987 0.582031C3.45495 0.582031 0.582031 3.45495 0.582031 6.9987C0.582031 10.5424 3.45495 13.4154 6.9987 13.4154C10.5424 13.4154 13.4154 10.5424 13.4154 6.9987C13.4154 3.45495 10.5424 0.582031 6.9987 0.582031ZM6.70703 3.4987C6.55232 3.4987 6.40395 3.56016 6.29455 3.66955C6.18516 3.77895 6.1237 3.92732 6.1237 4.08203C6.1237 4.23674 6.18516 4.38511 6.29455 4.49451C6.40395 4.60391 6.55232 4.66536 6.70703 4.66536H6.9987C7.15341 4.66536 7.30178 4.60391 7.41118 4.49451C7.52057 4.38511 7.58203 4.23674 7.58203 4.08203C7.58203 3.92732 7.52057 3.77895 7.41118 3.66955C7.30178 3.56016 7.15341 3.4987 6.9987 3.4987H6.70703ZM5.83203 5.83203C5.67732 5.83203 5.52895 5.89349 5.41955 6.00289C5.31016 6.11228 5.2487 6.26066 5.2487 6.41537C5.2487 6.57007 5.31016 6.71845 5.41955 6.82784C5.52895 6.93724 5.67732 6.9987 5.83203 6.9987H6.41537V8.7487H5.83203C5.67732 8.7487 5.52895 8.81016 5.41955 8.91955C5.31016 9.02895 5.2487 9.17732 5.2487 9.33203C5.2487 9.48674 5.31016 9.63511 5.41955 9.74451C5.52895 9.85391 5.67732 9.91537 5.83203 9.91537H8.16537C8.32007 9.91537 8.46845 9.85391 8.57784 9.74451C8.68724 9.63511 8.7487 9.48674 8.7487 9.33203C8.7487 9.17732 8.68724 9.02895 8.57784 8.91955C8.46845 8.81016 8.32007 8.7487 8.16537 8.7487H7.58203V6.41537C7.58203 6.26066 7.52057 6.11228 7.41118 6.00289C7.30178 5.89349 7.15341 5.83203 6.9987 5.83203H5.83203Z" fill="#585050"/>
              </g>
              <defs>
                <clipPath id="clip0_1441_26168">
                  <rect width="14" height="14" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="subtitle" [style.color]="color">{{description}}</div>
      </div>
      <div>
        <p-checkbox [binary]="true" inputId="binary" (onChange)="valueChange.emit($event)"></p-checkbox>
      </div>
    </div>
  </div>